export default __webpack_public_path__ + "static/media/institute-3-min.89205b71.webp";